const setResponsiveCellHeaders = (table, tableIndex) => {
    try {
        const THarray = [];
        table.classList.add(`table-${tableIndex}`);
        const ths = table.querySelectorAll('thead > tr > [role=columnheader]');
        for (const heading of ths) {
            const headingText = heading.innerHTML;
            THarray.push(headingText);
        }
        const styleElm = document.createElement('style');
        document.head.appendChild(styleElm);
        const styleSheet = styleElm.sheet;
        for (const [i, heading] of THarray.entries()) {
            styleSheet === null || styleSheet === void 0 ? void 0 : styleSheet.insertRule(`.table-${tableIndex} tbody td:nth-child(${i + 1})::before {content:"${heading}";}`, styleSheet.cssRules.length);
        }
    }
    catch (e) {
        console.log(`setResponsiveCellHeaders(): ${e}`);
    }
};
const addAria = (elementSelector, attributeValue) => {
    const elements = document.querySelectorAll(elementSelector);
    for (let i = 0; i < elements.length; i += 1) {
        elements[i].setAttribute('role', attributeValue);
    }
};
const rolesArr = [
    {
        selector: 'table',
        role: 'table',
    },
    {
        selector: 'thead, tbody, tfoot',
        role: 'rowgroup',
    },
    {
        selector: 'tr',
        role: 'row',
    },
    {
        selector: 'tbody td',
        role: 'cell',
    },
    {
        selector: 'th',
        role: 'columnheader',
    },
    {
        selector: 'thead > tr > *',
        role: 'columnheader',
    },
    {
        selector: 'th[scope=row]',
        role: 'rowheader',
    },
];
// https://adrianroselli.com/2018/02/tables-css-display-properties-and-aria.html
// https://adrianroselli.com/2018/05/functions-to-add-aria-to-tables-and-lists.html
const addTableARIA = () => {
    try {
        rolesArr.forEach(element => addAria(element.selector, element.role));
        // caption role not needed as it is not a real role and
        // browsers do not dump their own role with display block
    }
    catch (e) {
        console.log(`addTableARIA(): ${e}`);
    }
};
document.addEventListener('DOMContentLoaded', () => {
    const tables = [...document.querySelectorAll('table')];
    addTableARIA();
    tables.forEach((table, index) => {
        setResponsiveCellHeaders(table, index + 1);
    });
});

export { addAria, addTableARIA, setResponsiveCellHeaders };
